import _ from 'lodash'

import keywords from '../keywords'


function prepFilteredSearchFilters(filters) {
  // Adds UI-specific properties to each filter
  return _.reduce(filters, (acc, filterGroup, filterGroupName) => {
    const newFilterGroup = filterGroup.map(filter => ({
      ...filter,
      answers: []
    }))

    acc[filterGroupName] = _.sortBy(newFilterGroup, 'order')

    return acc
  }, {})
}

function prepGuidedSearchSteps(steps) {
  // This step is "hard-coded" because it's just to display the results amount
  const resultsStep = {
    order: steps.length + 1,
    icon: require('../assets/icons/7-results.svg'),
    step_title: 'Results',
    question: ''
  }

  return [...steps, resultsStep]
}

// Lets us specify which ids we want in the whole list based on current list, ids to add and ids to exclude
function getActiveFilterIds(currentActiveFilterIds, idsToAdd = [], idsToExclude = []) {
  const ids = _.uniq([...currentActiveFilterIds, ...idsToAdd])
  return _.difference(ids, idsToExclude)
}

// Get all IDs for this filter and remove them from the active filters ID list (if they're already in there)
function excludeIdsForFilter(activeFilterIds, filterTerms, filterType) {
  let updatedActiveFilterIds;

  if (filterType === keywords.multiselect) {
    // IDs for multiselect filters live on both the parent ("Florida") and children (Florida counties)
    const idsToRemove = _.flatMap(filterTerms, term => {
      const childrenIds = term.children.map(child => child.id)
      // return all children IDs plus parent ID for each filter term
      return [...childrenIds, term.id]
    })
    updatedActiveFilterIds = getActiveFilterIds(activeFilterIds, [], idsToRemove)
  } else {
    const idsToRemove = filterTerms.map(term => term.id)
    updatedActiveFilterIds = getActiveFilterIds(activeFilterIds, [], idsToRemove)
  }

  return updatedActiveFilterIds
}

export default {
  prepFilteredSearchFilters,
  prepGuidedSearchSteps,
  getActiveFilterIds,
  excludeIdsForFilter
}
